import { render, staticRenderFns } from "./revisionLogs.vue?vue&type=template&id=de10bc60&"
import script from "./revisionLogs.vue?vue&type=script&lang=js&"
export * from "./revisionLogs.vue?vue&type=script&lang=js&"
import style0 from "./revisionLogs.vue?vue&type=style&index=0&id=de10bc60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports